// extracted by mini-css-extract-plugin
export default {"inputWrapper":"Date_inputWrapper__QQ5dZ","label":"Date_label__6m9Od","inputField":"Date_inputField__binIz"};